export var a11yAria = {
    toggle: {
        expanded: function (element) { return (element.getAttribute('aria-expanded') === "true" ? "false" : "true"); },
        hidden: function (element) { return (element.getAttribute('aria-hidden') === "true" ? "false" : "true"); },
        label: function (element, initialValue, toggleValue) { return (element.getAttribute('aria-label') === initialValue ? toggleValue : initialValue); }
    },
    add: {
        expanded: function (element, value) { return (element.getAttribute('aria-expanded') === value); },
        hidden: function (element, value) { return (element.getAttribute('aria-hidden') === value); },
        label: function (element, value) { return (element.getAttribute('aria-label') === value); }
    },
};
